import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

function Php_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <Php_FAQ/>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none">
              <Php_FAQ/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function Php_FAQ(){
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What are the features of Android architecture?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Android architecture refers to the various layers in the Android stack. It consists of operating systems, middleware, and applications. Each layer in the Android architecture gives different services to the layer just above it.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>List the languages used to build Android.</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          The most popular programming languages that can be used to develop applications in Android are: 
          <br></br>  
          <ul>
            <li>Java: It has always been a starting point for new developers and used by the majority of people who work with Android development. Eclipse, NetBeans, and IntelliJ IDE are the most popular IDE’s(Integrated Development Environment) used for developing an Android application using java.</li>
            <li>Kotlin: Kotlin is a relatively new, modern, safe, and object-oriented cross-platform programming language used in developing an Android application. IDE’s used with kotlin are Android studio, Eclipse IDE, etc.</li>
          </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What is a service in Android?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Service is an application component that facilitates an application to run in the background in order to perform long-running operations without user interaction. A service can run continuously in the background even if the application is closed or even after the user switches to another application.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default Php_FAQ_page
